import { lazy } from 'react';

const SignIn = lazy(() =>
  import(/* webpackChunkName: "SignIn" */ '@common2/Authorization/SignIn/SignIn')
);

export default SignIn;
